<template>
    <section class="activity-areas" :class="$mq">
        <div class="container">
            <h1 class="title text-center">Secteurs d'activité</h1>
            <p class="subtitle text-center">
                Jouissant d'une excellente réputation, <b style='color: #d3031c;'>Blanchard</b> fournit en pièces métalliques et mécaniques de nombreux clients travaillant 
                dans <b style='color: #d3031c;'>de multiples secteurs d'activités</b> : matériel de lutte incendie, machinisme agricole, bâtiment et travaux publics, filtration, 
                convoyage industriel, sous-traitance industrielle, outillage, et bien plus encore.
            </p>
        </div>
        
        <div class="container-fluid">
            <div class="gallery-image-container mt-5">
                <div class="gallery" v-for="(activity, idx) in activities" :key="idx">
                    <img :src="activity.image" :alt="activity.alt" />
                    <div class="caption">
                        <h3 class="caption-title">{{ activity.title }}</h3>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ActivityAreas",

    data() {
        return {
            activities: [
                {
                    image: require("../../assets/img/activites/pompiers.jpg"),
                    alt: "",
                    title: "Matériel de lutte incendie"
                },
                {
                    image: require("../../assets/img/activites/agri.jpg"),
                    alt: "",
                    title: "Machinisme agricole"
                },
                {
                    image: require("../../assets/img/activites/building.jpg"),
                    alt: "",
                    title: "Bâtiment et travaux publics"
                },
                {
                    image: require("../../assets/img/activites/industry.jpg"),
                    alt: "",
                    title: "Industrie"
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
.activity-areas {
    margin: 50px auto;

    .gallery-image-container {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 50px;

        .gallery {
            position: relative;
            overflow: hidden;
            cursor: pointer;

            img {
                transform: scale(1);
                transform-origin: 50% 50%;
                transition: 450ms ease-in-out;
                max-width: 100%;
            }

            .caption {
                color: $primary;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                opacity: 0;
                transition: 450ms ease-in-out;
            }

            &:hover {
                .caption {
                    opacity: 1;
                }

                img {
                    transform: scale(1.1);
                    transform-origin: 50% 50%;
                    transition: 450ms ease-in-out;
                    opacity: .5;
                }
            }
        }
    }

    &.tablet, &.mobile {
        .gallery {
            img {
                opacity: .5;
            }

            .caption {
                text-align: center;
                opacity: 1;
                width: 75%;
            }
        }
    }

    &.mobile {
        .gallery-image-container {
            grid-template-columns: 1fr;
            grid-gap: 20px;
        }
    }
}
</style>